import { useEffect, useState } from "react";
import { useTranslationContext } from "../../context/TranslationContext";

const cache = {}; // Cache para almacenar traducciones previas

const TranslatableText = ({ text, format = "text", ...props }) => {
  const { translateText, targetLang } = useTranslationContext();
  const [translatedContent, setTranslatedContent] = useState(null); // Contenido traducido (texto o HTML)

  useEffect(() => {
    const cacheKey = `${text}-${targetLang}-${format}`;

    // Si el contenido ya existe en la caché, úsalo directamente
    if (cache[cacheKey]) {
      setTranslatedContent(cache[cacheKey]);
      return;
    }

    // Evitar traducción si el idioma es "es" o el contenido está vacío
    if (!text || targetLang === "es") {
      setTranslatedContent(text);
      return;
    }

    const translate = async () => {
      try {
        const result = await translateText(text, format);
        cache[cacheKey] = result; // Guarda el contenido en la caché
        setTranslatedContent(result);
      } catch (error) {
        setTranslatedContent(text); // Usa el contenido original en caso de error
      }
    };

    translate();
  }, [text, targetLang, format, translateText]);

  if (format === "html") {
    // Si el formato es HTML, usar dangerouslySetInnerHTML
    return (
      <span
        {...props}
        dangerouslySetInnerHTML={{
          __html: translatedContent || "",
        }}
      />
    );
  }

  // Si el formato es texto plano, renderizar directamente
  return <>{translatedContent || ""}</>;
};

export default TranslatableText;
